var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('div',{staticClass:"w-screen h-ipad bg-black text-white antialiased flex flex-col items-center text-base",attrs:{"id":"app"}},[_c('NavBar'),_c('router-view'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }